module.exports = __webpack_public_path__ + "img/Journal.f00653f0.svg";